import React from 'react';
import { MANAGE_COMPANY_USERS_SUBTITLE, MANAGE_COMPANY_USERS_TITLE } from 'common/constants/user';
import { Dialog } from 'components/Dialogs';
import { ManageCompanyUsersDialogProps } from './types';
import ManageCompanyUsersLedger from '../../ManageCompanyUsersLedger/ManageCompanyUsersLedger';

const ManageCompanyUsersDialog = ({
  handleDialogClose,
  dialogUserData,
  companyList,
  firmUsers,
  firm,
  fundList,
}: ManageCompanyUsersDialogProps) => (
  <Dialog
    title={MANAGE_COMPANY_USERS_TITLE}
    subtitle={MANAGE_COMPANY_USERS_SUBTITLE}
    onClose={handleDialogClose}
    open={dialogUserData.open}
    fullWidth>
    <div />
    <ManageCompanyUsersLedger
      companyList={companyList}
      firmUsers={firmUsers}
      firmId={firm.id}
      fundList={fundList}
      handleManageCompanyUsersDialogClose={handleDialogClose}
    />
  </Dialog>
);

export default ManageCompanyUsersDialog;
